import { Link, useParams } from 'react-router-dom';
import { getGuideBySlug } from '@/lib/guides';
import { renderMarkdown } from '@/lib/markdown';

export function GuideDetailPage() {
  const { slug } = useParams();
  const guide = slug ? getGuideBySlug(slug) : undefined;

  if (!guide) {
    return (
      <p role="alert">
        Guide not found. <Link to="/guides/">Back to guides</Link>
      </p>
    );
  }

  const html = renderMarkdown(guide.body);

  return (
    <article className="panel prose-page">
      <p className="eyebrow">
        <Link to="/guides/">Guides</Link>
      </p>
      <h1>{guide.title}</h1>
      <p className="muted">{guide.description}</p>
      <p className="muted">Updated {guide.updated}</p>
      <div
        className="guide-body"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <p>
        <Link to="/guides/">All guides</Link>
        {' · '}
        <Link to="/compare/">Open compare</Link>
        {' · '}
        <Link to="/methodology/">Methodology</Link>
      </p>
    </article>
  );
}
